// extracted by mini-css-extract-plugin
export var avatarContainer = "_4e-1";
export var largeAvatarContainer = "_4e-2";
export var smallAvatarContainer = "_4e-0";